"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16ToteLine = function Svg16ToteLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M9.5 10.5a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.692 9.48l-1.449 5.793-.02.085c-.072.302-.221.931-.602 1.44a3 3 0 0 1-1.24.968c-.586.246-1.232.238-1.543.235L14.75 18H9.162c-.31.004-.957.012-1.543-.234a3 3 0 0 1-1.24-.968c-.38-.509-.53-1.138-.602-1.44l-.02-.085L4.308 9.48 4.3 9.446c-.034-.136-.087-.345-.117-.538a2.516 2.516 0 0 1 .069-1.146 2.5 2.5 0 0 1 1.093-1.4c.441-.268.87-.325 1.096-.345C6.635 6 6.85 6 6.99 6H17.01c.14 0 .355 0 .55.017.225.02.654.077 1.095.345a2.5 2.5 0 0 1 1.093 1.4c.152.493.104.922.07 1.146-.031.193-.084.402-.118.538l-.008.033zm-2.073-1.408C17.499 8 17.325 8 16.975 8h-9.95c-.35 0-.524 0-.644.072a.5.5 0 0 0-.218.28c-.042.134 0 .303.085.642l1.449 5.794c.108.433.162.65.283.811a1 1 0 0 0 .413.323c.186.078.41.078.856.078h5.502c.446 0 .67 0 .856-.078a1 1 0 0 0 .413-.323c.12-.161.175-.378.283-.811l1.448-5.794c.085-.339.127-.508.086-.642a.5.5 0 0 0-.218-.28z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16ToteLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16ToteLine;
exports.default = _default;